import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { observer, PropTypes as mbxPropTypes } from "mobx-react";

// Icons
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import EditIcon from "@material-ui/icons/Edit";

const MenuActions = observer(
  ({ classes, player, idPlayer, anchorEls, handleClick, handleClose }) => {
    return (
      <React.Fragment>
        <IconButton
          {...{
            "aria-label": "actions",
            "aria-owns": anchorEls[idPlayer]
              ? `agent-actions-${idPlayer}`
              : null,
            "aria-haspopup": true,
            onClick: (e) => handleClick(idPlayer, e),
          }}
        >
          <MoreVertIcon color="primary" />
        </IconButton>

        <Menu
          {...{
            id: `agent-actions-${idPlayer}`,
            anchorEl: anchorEls[idPlayer],
            open: Boolean(anchorEls[idPlayer]),
            onClose: handleClose(idPlayer),
            PaperProps: {
              style: { width: 200 },
            },
          }}
        >
          <MenuItem
            className={classes.menuItem}
            onClick={handleClose(idPlayer, "edit", player)}
          >
            <ListItemIcon className={classes.icon}>
              <EditIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.primary }}
              inset
              primary="Edit"
            />
          </MenuItem>
          <MenuItem
            className={classes.menuItem}
            onClick={handleClose(idPlayer, "delete", player)}
          >
            <ListItemIcon className={classes.icon}>
              <DeleteRoundedIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.primary }}
              inset
              primary="Delete"
            />
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
);

MenuActions.propTypes = {
  classes: PropTypes.object.isRequired,
  playerList: mbxPropTypes.observableArrayOf(PropTypes.object),
};

export default MenuActions;
